<template>

    <div class="text-left no-print mx-0 px-0">
      <v-menu ref="menu" v-model="active" offset-x min-width="300px" min-height="300px" :close-on-content-click="false" class="no-print">
    
        <template v-slot:activator="{ on: { click }, attrs }">
    
          <v-card class="card px-0 py-0">
            <v-card-title class="card-title pb-0 mb-0"> Informações Contrato </v-card-title>
            <v-card-text> 
              <v-simple-table class="table mt-0 pt-0" >
                <template v-slot:default>
                  <thead>
                    <tr class="py-0 my-0"></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tipo:</td>
                      <td class="text-right"> {{  item.types.name }} </td>
                    </tr>

                    <tr>
                      <td> Descrição:</td>
                      <td class="text-right"> {{  item.types.description }} </td>
                    </tr>

                    <template v-for="(it, k) in item.contractRangeValues">
                      <tr :key="it.id" v-if="k < 1">
                            <td class="text-center title" colspan="2"> <strong> Contrato de valores: </strong> <br></td>
                        </tr>

                        <tr :key="it.id + 1000000">
                            <td> REC: </td>
                            <td class="text-right"> {{ formatTipoRec(it.regionProductId) }} </td>    
                        </tr>

                        <tr :key="it.id + 10000">
                            <td> Tipo: </td>
                            <td class="text-right"> {{  formatTipoComissao(it.comissionTypeId)  }} </td>    
                        </tr>

                        <tr :key="it.id + 20000">
                            <td> Valor Mínimo: </td>
                            <td class="text-right"> {{  it.minRange || 0 | currencyNoSymbol }} </td>    
                        </tr>

                        <tr :key="it.id + 30000">
                            <td> Valor Máximo: </td>
                            <td class="text-right f24" v-if=" item.types.id === 'REC' && it.maxRange > 99999999999999">
                              ∞
                            </td>    
                            <td v-else class="text-right">
                              {{  it.maxRange || 0 | currencyNoSymbol }} 
                            </td>    
                        </tr>

                        <tr :key="it.id + 40000">
                            <td>  Alíquota </td>
                            <td class="text-right"> {{  it.aliquot || 0 }} %</td>    
                        </tr>

                        <tr :key="it.id + 50000">
                          <td class="dividir" colspan="2"> </td>   
                        </tr>
                    </template>

                    <!-- Condicoes contrato com operador = | > | =< ... -->
                    <template v-for="(it, k) in item.conditions">
                        <tr :key="it.id" v-if="k < 1">
                            <td class="text-center title" colspan="2"> <strong> Condições do Contrato: </strong> <br></td>
                        </tr>
                        <tr :key="it.id + 60000">
                            <td>  Tipo: <br></td>
                            <td class="text-right"> {{ formatConditionName(it.fieldId) }} </td>    
                        </tr>

                        <tr :key="it.id + 700000">
                            <td>  Operador: </td>
                            <td class="text-right"> <span> {{ it.operator }} </span> </td>    
                        </tr>

                        <tr :key="it.id + 800000">
                            <td>  Valor: </td>
                            <td class="text-right"> {{  it.value || 0 | currencyNoSymbol }} </td>
                        </tr>

                        <tr :key="it.id + 80000">
                          <td class="dividir" colspan="2"> </td>   
                        </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>  
            </v-card-text>
          </v-card>
        </template>
        </v-menu>
      </div>
    </template>
    
    <script>
    // eslint-disable-next-line
    import moment from 'moment'
    import variables from '@/assets/styles/helpers/_variables.scss'
    import { mapGetters } from 'vuex'
    moment.locales('pt-br')
    export default {
      name: 'FinanceiroTooltipLancamento',
      components: {
      },
      props:['item'],
    
      data: () => ({
        loadingRelatorio: false,
        deleted: {},
        active: false,
        loading: false
      }),
    
      mounted () {},
      computed: {
        ...mapGetters('entities', ['listaItens']),
        ...mapGetters('entryTypes', ['listaPaths']),
        ...mapGetters('afiliadosContratos', ['listTipeSelectComissionFilter', 'getConditionsName']),
        variables: () => variables
      },
      methods: {
        getColor (status) {
          return status === 'B' ? this.variables.colorSecondary : this.variables.colorPrimary
        },
        formatTipoComissao(it) {
          const tipo = this.listTipeSelectComissionFilter(false, it)
          if (tipo[0]) return tipo[0].name
          return tipo
        },

        formatTipoRec(it){
          if(it === 1){
            return "Cassino"
          }else if (it === 2){
            return "Prognóstico"
          }else{
            return "Cassino e Prognóstico"
          }
        },
        
        formatConditionName(it) {
          const tipo = this.getConditionsName(it)          
          if (tipo[0]) return tipo[0].text
          return tipo
        }
      }
    }
    </script>
    <style lang="scss" scoped>
    @import "~@/assets/styles/helpers/variables";
.loader {
  min-height: 300px;
  justify-content: center;
  align-items: center;
  background: white;
}
.card {
  &-title {
    font-weight: bold;
    font-size: 14px;
    padding-bottom: 0;
  }
}
.v-tooltip__content {
  opacity: 1 !important;
}

table tbody tr {
  border-top: transparent !important;
  td{
    font-size: 12px !important;
    height: 30px !important;
    &.title {
      font-size: 14px !important;
    }
    &.dividir {
      height: 1px !important;
      background: rgba(0, 0, 0, 0.87)
    }

    span {
      background: cadetblue;
      display: block;
      width: 30px;
      min-width: 30px;
      border-radius: 10px;
      color: white;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      margin: 0 0 0 auto;
    }
  }
}

</style>